export { default } from "./SupportYourTeamTextBlockCardImageCta";
